import { About } from './components/About';
import { Contact } from './components/Contact';
import { Experience } from './components/Experience';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { Nav } from './components/Nav';
import { ResumeBand } from './components/ResumeBand';
import { Skills } from './components/Skills';
import { Work } from './components/Work';
import { useReveal } from './hooks/useReveal';

export default function App() {
  useReveal();

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <Nav />

      <main id="main">
        <Hero />
        <About />
        <Work />
        <Experience />
        <Skills />
        <ResumeBand />
        <Contact />
      </main>

      <Footer />
    </>
  );
}
